

const achievements = [
  ["😱", "Extrovert", 0, 0],
  ["😐", "Vibe killer", 0, 1],
  ["😸", "Pussy expert", 0, 2],
  ["👯‍♀️", "Doppelgänger<small><small>|available in full version|</small></small>", 0, 3],
  ["🙅‍♂️", "Way off track<small><small>|available in full version|</small></small>", 0, 4],
  ["💦", "Impress professor<small><small>|available in full version|</small></small>", 0, 5],
  ["✍️", "Helper<small><small>|available in full version|</small></small>", 0, 6],
];

export default achievements;
